import { render } from "./TemplateDialog.vue?vue&type=template&id=22cd8b4e"
import script from "./TemplateDialog.vue?vue&type=script&lang=js"
export * from "./TemplateDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__